export type IntakeSummaryExperimentStatus = 'loading' | 'ready' | 'error';
export type IntakeSummaryExperimentExperience = 'control' | 'treatment';

export interface ResolveIntakeSummaryExperienceInput {
  status: IntakeSummaryExperimentStatus;
  cutoverAt: Date | null;
  now: Date;
  recordedAllocationValue: string | null | undefined;
}

/**
 * Resolves intake summary experiment experience after cutover from the Redis-recorded
 * allocation anchor (same source as banner/cutover), not live Statsig.
 */
export function resolveIntakeSummaryExperience({
  status,
  cutoverAt,
  now,
  recordedAllocationValue,
}: ResolveIntakeSummaryExperienceInput): IntakeSummaryExperimentExperience {
  if (status !== 'ready') {
    return 'control';
  }

  if (!cutoverAt || now.getTime() < cutoverAt.getTime()) {
    return 'control';
  }

  if (recordedAllocationValue === null || recordedAllocationValue === undefined) {
    return 'control';
  }

  return recordedAllocationValue === 'true' ? 'treatment' : 'control';
}
